import { Component, ViewChild } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavbarStatus, NavigationItem, NavigationService } from 'src/app/core/navigation.service';
import { UtilsService } from 'src/app/core/utils.service';
import { LOCAL_NAVBAR_STATUS_KEY } from 'src/app/shared/constants/operationals';
import { NavigationItemLabel } from 'src/app/shared/constants/translations';
import { CompanyDetailsGeneralComponent } from '../company-details-general/company-details-general.component';
import { CompanyDetailsStoreDataComponent } from '../company-details-store-data/company-details-store-data.component';
import { CompanyDetailsTeamDataComponent } from '../company-details-team-data/company-details-team-data.component';
import { CompanyDetailsEventDataComponent } from '../company-details-event-data/company-details-event-data.component';
import { CompanyDetailsPendingInvitationsDataComponent } from '../company-details-pending-invitations-data/company-details-pending-invitations-data.component';
import { CompanyDetailsOrderDataComponent } from '../company-details-order-data/company-details-order-data.component';
import { CompanyDetailsUnpaidDataComponent } from '../company-details-unpaid-data/company-details-unpaid-data.component';
//import { StoreDetailsEventDataComponent } from 'src/app/store-details/store-details-event-data/store-details-event-data.component';
//import { StoreDetailsTeamDataComponent } from 'src/app/store-details/store-details-team-data/store-details-team-data.component';

@Component({
  selector: 'app-company-details',
  templateUrl: './company-details.component.html',
  styleUrls: ['./company-details.component.scss'],
})
export class CompanyDetailsComponent {
  @ViewChild(CompanyDetailsGeneralComponent) general_component?: CompanyDetailsGeneralComponent;
  @ViewChild(CompanyDetailsStoreDataComponent) store_component?: CompanyDetailsStoreDataComponent;
  @ViewChild(CompanyDetailsTeamDataComponent) team_component?: CompanyDetailsTeamDataComponent;
  @ViewChild(CompanyDetailsEventDataComponent) event_component?: CompanyDetailsEventDataComponent;
  @ViewChild(CompanyDetailsPendingInvitationsDataComponent)
  pending_invitation_component?: CompanyDetailsPendingInvitationsDataComponent;
  @ViewChild(CompanyDetailsOrderDataComponent) order_component?: CompanyDetailsOrderDataComponent;
  @ViewChild(CompanyDetailsUnpaidDataComponent) unpaid_component?: CompanyDetailsUnpaidDataComponent;

  navbar_status: NavbarStatus;
  current_nav_item?: NavigationItem = this.navigation_service.navigation_set.nav_items.get(
    NavigationItemLabel.companies,
  );

  company_id: string | null;

  tabs = this.navigation_service.navigation_set.company_details_tabs;
  current_tab = this.tabs.get('article');

  constructor(
    private navigation_service: NavigationService,
    private utils_service: UtilsService,
    private route: ActivatedRoute,
  ) {
    this.navbar_status = (localStorage.getItem(LOCAL_NAVBAR_STATUS_KEY) as NavbarStatus) || NavbarStatus.closed;
    this.company_id = this.route.snapshot.paramMap.get('company_id');
  }

  ngOnInit(): void {
    this.current_tab = this.tabs.get('article');
  }

  onRefresh(): void {
    if (this.current_tab === this.tabs.get('article')) {
      this.general_component?.onRefresh();
    }

    if (this.current_tab === this.tabs.get('group')) {
      this.team_component?.onRefresh();
    }

    if (this.current_tab === this.tabs.get('timeline')) {
      this.event_component?.onRefresh();
    }

    if (this.current_tab === this.tabs.get('storefront')) {
      this.store_component?.onRefresh();
    }

    if (this.current_tab === this.tabs.get('mail_outline')) {
      this.pending_invitation_component?.onRefresh();
    }

    if (this.current_tab === this.tabs.get('receipt_long')) {
      this.order_component?.onRefresh();
    }

    if (this.current_tab === this.tabs.get('money_off')) {
      this.unpaid_component?.onRefresh();
    }
  }

  onTabChange(current_tab: string): void {
    this.current_tab = current_tab;
  }

  onNavbarStatusChange(navbar_status: NavbarStatus): void {
    this.navbar_status = navbar_status;
    localStorage.setItem(LOCAL_NAVBAR_STATUS_KEY, navbar_status);
  }

  getNavbarClass(): { [key: string]: boolean | undefined } {
    return this.utils_service.getNavbarClass(this.navbar_status);
  }

  getToolbarWidthClass(): string {
    if (this.navbar_status == NavbarStatus.open) {
      return 'sp-toolbar__open-width';
    }
    return 'sp-toolbar__closed-width';
  }
}
